import React from 'react';
import PropTypes from 'prop-types';

export default class UserTackProgressHeader extends React.Component {
  static propTypes = {
    currentInterval: PropTypes.number
  }

  constructor(props) {
    super(props);
    this.state = {
      showTooltip: false,
      tooltipContent: '',
      tooltipPosition: { x: 0, y: 0 },
      tooltipAlignment: 'center'
    };
  }

  handleIntervalClick = (event, title) => {
    const rect = event.currentTarget.getBoundingClientRect();
    const centerX = rect.left + rect.width / 2;
    const viewportWidth = window.innerWidth;
    const tooltipWidth = 120; // Approximate tooltip width

    // Calculate safe x position
    let safeX = centerX;
    let alignment = 'center';

    if (centerX - tooltipWidth / 2 < 10) {
      // Too close to left edge
      safeX = rect.left;
      alignment = 'left';
    } else if (centerX + tooltipWidth / 2 > viewportWidth - 10) {
      // Too close to right edge
      safeX = rect.right;
      alignment = 'right';
    }

    this.setState({
      showTooltip: true,
      tooltipContent: title,
      tooltipPosition: {
        x: safeX,
        y: rect.top
      },
      tooltipAlignment: alignment
    });
  }

  closeTooltip = () => {
    this.setState({ showTooltip: false });
  }

  render() {
    const intervals = [1, 2, 3, 5, 8, 13];
    const minInterval = Math.min(...intervals);
    const maxInterval = Math.max(...intervals);
    const totalSpan = maxInterval - minInterval;

    const intervalNodes = intervals.map((interval) => {
      // Calculate proportional position (0 to 1)
      const position = (interval - minInterval) / totalSpan;

      let className, title;
      if (this.props.currentInterval === interval) {
        className = `interval-point interval-next interval-${interval}`;
        title = `Currently on: Day ${interval}`;
      } else if (this.props.currentInterval >= interval) {
        className = `interval-point interval-completed interval-${interval}`;
        title = `Completed: Day ${interval}`;
      } else {
        className = `interval-point interval-pending interval-${interval}`;
        title = `Upcoming: Day ${interval}`;
      }

      return (
        <li
          key={interval}
          style={{ left: `${position * 100}%`, cursor: 'pointer' }}
          onClick={(e) => this.handleIntervalClick(e, title)}
        >
          <span title={title} className={className}>&nbsp;</span>
          {this.props.currentInterval === interval && (
            <div className={`current-label ${position <= 0.2 ? 'align-left' : position >= 0.8 ? 'align-right' : 'align-center'}`}>current</div>
          )}
        </li>
      );
    });

    return (
      <div>
        <ul className='tack-progress-header'>
          {intervalNodes}
        </ul>
        {this.state.showTooltip && (
          <React.Fragment>
            <div className="tooltip-overlay" onClick={this.closeTooltip}></div>
            <div
              className={`interval-tooltip tooltip-${this.state.tooltipAlignment}`}
              style={{
                left: this.state.tooltipPosition.x,
                top: this.state.tooltipPosition.y
              }}
            >
              {this.state.tooltipContent}
            </div>
          </React.Fragment>
        )}
      </div>
    )
  }
}



// WEBPACK FOOTER //
// ./src/components/user_tack_progress_header.jsx